module.exports = __webpack_public_path__ + "img/ico_list_active.04bfddae.svg";